import { render, staticRenderFns } from "./CurrentAddressMacao.vue?vue&type=template&id=e8c7bf4c&scoped=true&"
import script from "./CurrentAddressMacao.vue?vue&type=script&lang=js&"
export * from "./CurrentAddressMacao.vue?vue&type=script&lang=js&"
import style0 from "./CurrentAddressMacao.vue?vue&type=style&index=0&id=e8c7bf4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c7bf4c",
  null
  
)

export default component.exports